<template>
  <div class="header-wrap">
    <header>
      <div class="header-left">
        <img style="width: 145px" src="../assets/companyLogo.png" />
      </div>
      <div class="header-right">
        <!-- <el-popover placement="bottom" width="255" trigger="hover">
          <div class="apps">
            <div class="appitem" @click="linktoapp('/index')">
              <img src="@/assets/gzt.png" alt="" />
              <div class="appname">悦享工资条</div>
            </div>
            <div class="appitem" @click="linktoapp('/smsindex')">
              <img src="@/assets/sms.png" alt="" />
              <div class="appname">短信中心</div>
            </div>
            <div class="appitem" @click="linktoapp('/lovecardindex')">
              <img src="@/assets/love.png" alt="" />
              <div class="appname">悦享心语</div>
            </div>
          </div>
          <div class="otherapp" slot="reference">
            <img src="@/assets/allappicon.png" alt="" />
            <span>全部应用</span>
          </div>
        </el-popover> -->

        <!-- <div class="msg" style="margin-left: 19px">
          <img src="@/assets/msgicon.png" alt="" />
          <span>消息</span>
        </div> -->

        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            {{ this.orgInfo.orgName | limitWords(10)
            }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              icon="el-icon-office-building"
              @click.native="tootherindex"
              >企业中心</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="logout"
              icon="el-icon-switch-button"
              >退出</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <div class="line"></div>

        <div class="msg" @click="tohelpcenter">
          <img src="@/assets/help.png" alt="" />
          <span>帮助</span>
        </div>
        <div class="line"></div>
        <apps />
      </div>
    </header>
  </div>
</template>

<script>
import Cookie from "js-cookie";

// qywxauthor
import { qywxauthor } from "@/api/setUp.js";

import apps from "./apps";

export default {
  components: {
    apps,
  },
  created() {
    this.getUserInfo();
  },
  data() {
    return {
      userInfo: [],
      orgInfo: [],
    };
  },
  methods: {
    async toqywx() {
      let { data } = await qywxauthor();
      if (data) {
        window.open(data);
      }
    },
    getUserInfo() {
      this.$http.get("authority-center/common/user/info").then((res) => {
        this.orgInfo = res.data;
        this.$http.get(`authority-center/org/${res.data.orgId}`).then((res) => {
          this.userInfo = res.data;
        });
      });
    },
    toindex() {
      this.$router.push("index");
    },
    tootherindex() {
      // window.location.href = 'http://ucenter.prosuntech.com/#/enterpriseIndex';
      window.location.href = "https://ucenter.joyousoa.com/#/enterpriseIndex";
    },
    tohelpcenter() {
      window.open("https://help.joyousoa.com/");
    },
    linktoapp(path) {
      this.$router.push(path);
    },
    logout() {
      window.sessionStorage.removeItem("token");
      Cookie.remove("token", { path: "/", domain: "192.168.0.118" });
      Cookie.remove("token", { path: "/", domain: "192.168.18.199" });
      Cookie.remove("token", { path: "/", domain: ".prosuntech.com" });
      Cookie.remove("token", { path: "/", domain: ".joyousoa.com" });
      this.$router.push("/login");
      window.location.reload();
    },
  },
};
</script>

<style lang="less" scoped>
.header-wrap {
  border-bottom: 1px solid rgba(204, 204, 204, 0.3);

  header {
    width: 97%;
    height: 60px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    .header-left {
      display: flex;
      align-items: center;
      justify-content: left;
    }

    .header-right {
      display: flex;
      align-items: center;
      justify-content: left;

      .company-name {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0a1629;
        line-height: 24px;
      }

      .line {
        width: 5px;
        transform: scaleX(0.2);
        // border-right: 1px solid #000;
        height: 24px;
        background: #000;
        opacity: 0.1;
        margin: 0 15px;
      }

      .el-dropdown-link {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0a1629;
        line-height: 24px;
      }

      .msg {
        display: flex;
        align-items: center;
        justify-content: left;
        cursor: pointer;

        span {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #0a1629;
          line-height: 24px;
          margin-left: 9px;
        }

        img {
          height: 17px;
        }
      }
    }
  }
}

/deep/.el-dropdown-link {
  cursor: pointer !important;
}

/deep/.el-dropdown-menu__item:not(.is-disabled):hover,
.el-dropdown-menu__item:focus {
  background: #fafafc;
  color: #606266 !important;
}

/deep/.el-dropdown-menu li:hover {
  color: #606266 !important;
}
</style>
